import { css } from "@emotion/react"

import { fontsCP } from "../../Tokens"

export const iqCard = css`.iq-card {
  font-family: ${ fontsCP["font-primary"]["font-family"]};
}`
